import { DomainError } from "../errors/index.js";
export function createAgentListQuery(repository) {
    return createListQuery("agents.list.v1", repository);
}
export function createAgentDetailQuery(repository) {
    return createDetailQuery("agents.detail.v1", repository);
}
export function createSettingsRevisionedListQuery(repository) {
    return createListQuery("settings.revisioned-list.v1", repository);
}
export function createSettingDetailQuery(repository) {
    return createDetailQuery("settings.revisioned-detail.v1", repository);
}
export function createGraphListQuery(repository) {
    return createListQuery("graphs.list.v1", repository);
}
export function createGraphDetailQuery(repository) {
    return createDetailQuery("graphs.detail.v1", repository);
}
export function parseRevisionDetailParams(value) {
    if (value === null || typeof value !== "object" || Array.isArray(value))
        throw invalid();
    const record = value;
    if (Object.keys(record).length !== 1 || typeof record.id !== "string" || record.id.trim() === "")
        throw invalid();
    return { id: record.id };
}
function createListQuery(name, repository) {
    return {
        invalidateOn: ["domain.entity-changed", "outbox.state-changed", "sync.delta-applied"],
        key: (row) => row.id,
        name,
        run: async (params) => {
            parseEmptyParams(params);
            return await repository.list();
        },
    };
}
function createDetailQuery(name, repository) {
    return {
        invalidateOn: ["domain.entity-changed", "outbox.state-changed", "sync.delta-applied"],
        key: (row) => row.id,
        name,
        run: async (params) => {
            const record = await repository.read(parseRevisionDetailParams(params).id);
            return record === undefined ? [] : [record];
        },
    };
}
function parseEmptyParams(value) {
    if (value === null || typeof value !== "object" || Array.isArray(value) || Object.keys(value).length !== 0) {
        throw new DomainError({ code: "invalid_request", message: "Invalid revision list query parameters" });
    }
}
function invalid() {
    return new DomainError({ code: "invalid_request", message: "Invalid revision detail parameters" });
}
//# sourceMappingURL=revisioned.js.map